import { type Provider, InjectionToken } from '@angular/core';

export interface SvgIconConfig {
  spriteUrl?: string;
}

export const SVG_SPRITE_URL = new InjectionToken<string | undefined>('SVG_SPRITE_URL');

export function provideSvgIcon(config: SvgIconConfig): Provider {
  return { provide: SVG_SPRITE_URL, useValue: config.spriteUrl };
}
